import { X } from "lucide-react";

// Fullscreen single-photo viewer, shared by the Scanner's pre-save photo list
// (LocalPhotosModal) and the saved-document photo list (DocumentsPage.jsx PhotosModal) — same
// component either way, only `src` differs (a base64 data URI vs. a documentFileUrl()).
export default function PhotoLightboxModal({ src, alt, onClose }) {
  return (
    <div
      className="fixed inset-0 bg-black/90 z-[500] flex items-center justify-center p-4"
      onMouseDown={e => e.target === e.currentTarget && onClose()}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 h-9 w-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
        title="Закрыть"
      >
        <X className="h-5 w-5" />
      </button>
      <img src={src} alt={alt || "Фото"} className="max-w-full max-h-full object-contain" />
    </div>
  );
}
